import React, { useMemo } from 'react'

import { MRT_ColumnDef } from '@tidbcloud/uikit/biz'

import { ClusterComputed } from '~/hooks/state'

import { EvictedSQL, SQLWithPopover } from '../../components/SQLWithPopover'
import { formatValue } from '../migration_shared/format-value'
import { StatementModel } from '../utils/type'

export const useStatementColumns = (
  data: StatementModel[],
  computed: ClusterComputed
) => {
  const columns = useMemo<MRT_ColumnDef<StatementModel>[]>(() => {
    const cols: MRT_ColumnDef<StatementModel>[] = [
      {
        id: 'digest_text',
        header: 'Statement Template',
        minSize: 300,
        enableSorting: false,
        accessorFn: (row) =>
          row.digest_text ? (
            <SQLWithPopover sql={row.digest_text} />
          ) : (
            <EvictedSQL />
          )
      },
      {
        id: 'sum_latency',
        header: 'Total Latency',
        enableResizing: false,
        accessorFn: (row) => formatValue(row, 'sum_latency', 'ns')
      },
      {
        id: 'avg_latency',
        header: 'Mean Latency',
        enableResizing: false,
        accessorFn: (row) => formatValue(row, 'avg_latency', 'ns')
      },
      {
        id: 'exec_count',
        header: 'Executions Count',
        enableResizing: false,
        accessorFn: (row) => formatValue(row, 'exec_count', 'short')
      },
      {
        id: 'plan_count',
        header: 'Plans Count',
        enableResizing: false,
        accessorFn: (row) => row.plan_count ?? 0
      }
    ]
    if (computed.isServerless || computed.isPremium) {
      cols.push({
        id: 'sum_ru',
        header: 'Total RU',
        enableResizing: false,
        accessorFn: (row) =>
          row.sum_ru !== undefined ? formatValue(row, 'sum_ru', 'short') : '0'
      })
      cols.push({
        id: 'avg_ru',
        header: 'Mean RU',
        enableResizing: false,
        accessorFn: (row) =>
          row.avg_ru !== undefined ? formatValue(row, 'avg_ru', 'short') : '0'
      })
    }
    return cols
  }, [data])

  return columns
}
